export default "__VITE_ASSET__993a5579__"